/* 88 Acres · announce-88.js · Announcement (88) ticker (option B2).
   - Sets the loop length from the content width so the speed (px/s) stays the same on any screen.
   - Pause button (aria-pressed). Hover and focus pausing is CSS.
   - announce_click to GA4 gtag + Shopify customer events. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('announce-88')) return;

  class Announce88 extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-a88-track]');
      this.btn = this.querySelector('[data-a88-pause]');
      var speed = parseFloat(this.dataset.speed) || 35;
      var self = this;

      function setDuration() {
        if (!self.track || !self.track.firstElementChild) return;
        var w = self.track.firstElementChild.offsetWidth;
        if (w > 0) self.style.setProperty('--a88-dur', (w / speed).toFixed(1) + 's');
      }
      setDuration();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(setDuration);
      if (window.ResizeObserver) {
        var lastW = 0;
        new ResizeObserver(function () {
          if (self.offsetWidth !== lastW) { lastW = self.offsetWidth; setDuration(); }
        }).observe(this);
      }

      if (this.btn) {
        this.btn.addEventListener('click', function () {
          var paused = self.classList.toggle('is-paused');
          self.btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        });
      }

      this.addEventListener('click', function (e) {
        var a = e.target.closest('a.a88-item');
        if (!a) return;
        var data = { link_label: a.getAttribute('data-a88-label') || '', link_url: a.href };
        try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('announce_click', data); } catch (err) {}
        try { if (typeof window.gtag === 'function') window.gtag('event', 'announce_click', data); } catch (err) {}
      });
    }
  }

  customElements.define('announce-88', Announce88);
})();
